// extracted by mini-css-extract-plugin
export default {"next":"bnc3"};